import React, { FunctionComponent } from 'react';

export const Presentation: FunctionComponent = () => {
  return (
    <div className="rtf-top-links">
        {/* start company-term */}
        <div className="company-terms">
            <div className="terms-body">
            <h2 className="title">利用規約（掲載企業向け）</h2>

            <p className="terms-statement">株式会社READY TO FASHION（以下「当社」といいます。）は、当社がSNSサービス「READY TO FASHION」を含むすべてのサービス（以下「本サービス」と総称します。）を提供するにあたり、以下のとおり利用規約（以下「本利用規約」といいます。）を定めています。本利用規約は、ユーザー（ユーザーとして「RTFユーザーアカウント」を登録し本サービスを利用されるすべての方をいいます。以下同じ。）に向けて情報を掲載する目的のため、掲載企業として「RTFカンパニーアカウント」（以下「本アカウント」といいます。）を登録し本サービスを利用されるすべての企業、各種団体、個人その他の利用者（法人、個人事業主を含みます。以下「掲載企業」といいます。）に適用されるため、本アカウントをご登録される前によくご覧ください。</p>


            <p className="terms-article-title">第1条（本サービスのご利用と本利用規約などへの同意）</p>

            <p>掲載企業は、本利用規約および当社が本サービスの提供にあたり定める各種規約（以下「本利用規約など」と総称します。）に同意することにより、本利用規約などの定めに従って本アカウントを登録し、本サービスを利用することができます。本利用規約などにご同意いただけない場合、本アカウントをご登録いただき本サービスをご利用いただくことができません。掲載企業は、実際に本アカウントを登録することにより、本利用規約などの内容にご同意いただいたものとみなされます。</p>

            <p className="terms-article-title"> 第2条（本アカウントの登録）</p>
            <ul>
                <li>1. 本アカウントの会員登録については、当社所定の方法により掲載企業に関する情報（次条に定める従事者数を含みますが、これに限られません。）を登録、送信することをもって、当該登録の申込みをしたものとみなします。</li>

                <li>2. 前項の申込みは、掲載企業において本サービスの利用に係る契約を締結する権限を有する者が行うものとします。無権限の者が申込みを行った場合、当該申込みは認められず、当該無権限者は、当該申込みによって当社その他の者に生じた損害を賠償する責を負うものとします。</li>

                <li>3. 当社は、第1項の申込みについて所定の審査を行うことができるものとします。</li>

                <li>4. 当社は、掲載企業として不適当と判断した場合には、本アカウントの登録を拒否することができるものとします。</li>

                <li>5.{'\u3000'}当社は、前項に基づき登録を拒否する場合、登録を拒否する理由を申込者に説明する義務を負わないものとします。</li>
            </ul>


            <p className="terms-article-title">第3条（従事者数の申告）</p>
            <ul>
              <li>1. 掲載企業は、本アカウントの登録ならびに本サービスの申込みおよび利用に際して、社員、従業員その他の従事者（役員、正社員、非正社員（契約社員、パートタイマーまたはアルバイトなどの呼称で採用された者をいいます。）またはインターンシップに基づく就労体験者などを含み、役職名、肩書を問わず、また、有給、無給を問わず、掲載企業の人材として掲載企業の事業に携わる者をいいます。以下同じ。）数を、当社の求めに応じ、当社が定める所定の方法により申告するものとします。</li>

              <li>2. 掲載企業は、本利用規約などに基づく契約を更新する場合、当該更新時における従事者数を、当社の求めに応じ、当社が定める所定の方法により申告するものとします。</li>

              <li>3. 掲載企業が、第1項または前項に定める従事者数の申告時に、事実と異なる不正確な情報を申告した場合、当該掲載企業は、当該申告によって当社に生じた損害（当社が従事者数に基づいて本サービスの利用料を算定する場合における真実の従事者数に基づいて算定された本来の本サービスの利用料を含みますが、これに限られません。）を賠償する責を負うものとします。</li>
            </ul>


            <p className="terms-article-title">第4条（本サービスの利用にあたって）</p>
            <ul>
                <li>1. 掲載企業は、自らの費用と責任において、本サービスの利用にあたって必要な機器・ソフトウェア・通信手段などを用意し、これらを適切に接続、操作するものとします。</li>

                <li>2. 掲載企業は、自らの費用と責任において、自己の利用環境に応じ、コンピュータウィルスの感染、不正アクセスおよび情報漏洩の防止などのセキュリティ対策を講じるものとします。</li>

                <li>3. 掲載企業は、本サービスの利用にあたって、当社に対し、職業安定法その他の法令などに抵触する可能性のある業務を委託することはできないこと、当社はユーザーと掲載企業の間の雇用関係成立を何らあっせんするものではないこと、実施の依頼を受けた業務について当社が当該法令などに違反すると判断した場合には当該業務の実施依頼を断ることができることをあらかじめ了承するものとします。この場合、掲載企業は当社に損害賠償請求をすることはできません。</li>
            </ul>


            <p className="terms-article-title">第5条（掲載企業に関する情報の取扱い）</p>
            <ul>
                <li>1. 当社は、掲載企業が本アカウントの登録ならびに本サービスの申込みおよび利用にあたって、当社に対して提供した情報（以下「掲載企業情報」といいます。）を、当社の「<a href="/privacy">プライバシーポリシー</a>」に基づき、適切に取り扱うものとします。</li>

                <li>2. 掲載企業は、当社が、掲載企業情報を、本サービスの提供に必要な範囲で、ユーザー、他の掲載企業または第三者の閲覧に供することをあらかじめ同意します。掲載企業は、掲載企業情報として提供されたコンテンツの公開について単独で責任を負います。掲載企業が公開を欲しない個人情報については、本サービス上で非公開とする、安易に書き込まないなどの方法により対処するなど、十分にご注意ください。</li>
            </ul>
            <p className="terms-article-title">第6条（利用履歴など）</p>
            <ul>
                <li>1.{'\u3000'}当社は、掲載企業の本サービスの利用履歴（ページビューを含みますが、これに限られません。以下同じ。）、または利用履歴、掲載企業に関する情報を、個人を識別、特定できないように加工、集計、および分析した統計データ、属性情報などを作成し、当該利用履歴または統計データ、属性情報などを何らの制限なく閲覧、利用（他の掲載企業へ閲覧させること、本サービスの新機能の開発、市場の調査を含みますが、これに限られません。）することができる（通信の秘密に抵触する場合を除きます。）ものとし、掲載企業はこれをあらかじめ承諾します。</li>

                <li>2.{'\u3000'}当社は、職業安定法その他の法令に反しない範囲で、掲載企業およびユーザーに対してのアンケートその他の方法により、本サービスの利用に関連した事実などを確認することができ、掲載企業はこれに協力するものとします。</li>

                <li>3.{'\u3000'}当社は、職業安定法その他の法令に反しない範囲で、前項のアンケートなどに対する回答を集計した結果や分析した統計データなどを、本サービス上に掲載することができるものとし、掲載企業はこれをあらかじめ承諾します。</li>
            </ul>
            <p className="terms-article-title">第7条（本サービスの内容に関する非保証）</p>
            <ul>
                <li>1.{'\u3000'}当社は、本サービスの品質にできる限りの注意を払っていますが、本サービスにより提供される情報（ユーザーが表明する情報、掲載企業またはユーザーが表明する掲載企業に関する情報および当社が提供する情報を含みます。）の完全性、正確性、有用性、最新性、真実性、エラー・バグなど不具合がないこと、セキュリティ上の欠陥が存在しないこと、支障なく完全に閲覧できること、掲載企業が期待する性質および商品的価値を有することなどについて保証するものではありません。また、本サービスにより提供される情報に基づいて掲載企業が下した判断および行動した結果について、当社は責任を負いません。</li>

                <li>2.{'\u3000'}当社は、掲載企業が実施するユーザー向け企画へのユーザーの参加、掲載企業によるユーザーの採用など、本サービスの効果一切について、その確実性を保証するものではありません。</li>

                <li>3.{'\u3000'}当社は、本サービスの確実な提供またはアクセス結果などにつき保証するものではありません。</li>

                <li>4.{'\u3000'}当社は、掲載企業に対し、ユーザーの資質・能力、掲載企業への適合性など、ユーザーに関する何らの保証も行わないものとします。</li>
            </ul>
            <p className="terms-article-title">第8条（本サービスの内容に関する変更）</p>

            <p>当社は、当社の判断において、掲載企業への事前の通知なくして、本サービスの内容もしくは仕様を変更し、または、本サービスの提供を停止することができるものとします。当社は、本サービスの変更などにより掲載企業または第三者が被った損害について、一切責任を負わないものとします。</p>

            <p className="terms-article-title">第9条（本サービスの利用制限）</p>
            <ul>
                <li>1. 当社は、本サービスのご利用を、当社が定める掲載企業情報の入力などの手続を経て一定の要件を満たした掲載企業のみに限定することなど、利用に際して条件を付することができるものとします。</li>

                <li>2. 掲載企業は、本サービスの利用にあたって、サービスの特性に照らして利用することができないサービスが存在することをあらかじめ了承するものとします。</li>

                <li>3. 当社は、反社会的勢力など（暴力団・暴力団員・総会屋・社会運動など標ぼうゴロ・特殊知能暴力集団その他これらに準ずる者を意味します。以下同じ。）または反社会的勢力などと何らかの関係を持っていると当社が判断した掲載企業、本サービスを悪用する掲載企業、第三者に迷惑をかける害意のある掲載企業に対しては、ご利用をお断りしています。</li>

                <li>4. 当社は、掲載企業が前項に規定する掲載企業であると判断した場合、何ら事前の催告を要することなく、掲載企業に対して通知し、即時に本利用規約などに基づく契約を解除することができるものとします。</li>

                <li>5. 当社が前項の規定により本利用規約などに基づく契約を解除した場合には、当社は、解除により掲載企業に生じた損害の一切について賠償する義務を負わないものとします。</li>
            </ul>
            <p className="terms-article-title">第10条（掲載企業情報の登録・修正）</p>
            <ul>
                <li>1. 掲載企業になろうとする者または掲載企業に、本アカウントの登録または本サービスの申込みもしくは利用にあたって自身の情報を登録していただく場合、（ア）真実かつ正確な情報を登録すること、（イ）登録情報が最新のものとなるよう適宜更新、修正すること、（ウ）登録情報の公開・非公開の設定その他の管理を行うことが、掲載企業の義務となります。</li>

                <li>2. 掲載企業になろうとする者または掲載企業が、前項の義務を怠ったことにより不利益を被ったとしても、当社は一切責任を負わないものとします。</li>
            </ul>
            <p className="terms-article-title">第11条（本アカウント情報の自己管理）</p>
            <ul>
                <li>1. 掲載企業の本アカウント情報は、掲載企業ご自身のみに適用されるアカウント情報として、掲載企業の責任において管理および保管するものとし、第三者に利用させてはならず、かつ、第三者に対して貸与、譲渡、名義変更、売買などをしてはならないものとします。</li>

                <li>2. 掲載企業は、当社による事前の同意なく、第三者に対して、掲載企業の本アカウント情報を用いた本サービスの操作または管理を委託してはならないものとします。当社の同意により委託する場合も、本利用規約などに基づく契約上の義務と同等の義務を当該第三者に負わせるものとし、かつ、掲載企業は責任を免れるものではありません。</li>

                <li>3. 当社は、掲載企業の本アカウント情報の一致を確認した場合、当該本アカウント情報を保有する者として登録された掲載企業が本サービスを利用したものとみなします。</li>

                <li>4. IDとパスワードの組み合わせなどのログインに必要とされる情報が一致してログインが行われた場合には、当社は、当該ログインに関する本アカウント情報を登録されている掲載企業ご自身によるご利用であるとみなし、当該本アカウント情報を用いたサービスの利用によって料金や代金（当社のサービスのご利用にかかる代金、広告料、利用料、会費その他名目は問いません。）が発生した場合には、当該本アカウント情報を登録されている掲載企業に課金します。</li>

                <li>5. 本アカウント情報が盗用された場合、または第三者に使用されていることが判明した場合には、掲載企業は、直ちにその旨を当社に通知し、当社の指定する措置を取るものとします。</li>

                <li>6. 掲載企業による本アカウント情報の管理不十分または第三者の利用などによる損害の責任は、掲載企業が負担するものとし、当社は責任を負わないものとします。</li>
            </ul>
            <p className="terms-article-title">第12条（利用料の支払い）</p>
            <ul>
                <li>1. 掲載企業は、当社が別途定める本サービスの利用料（以下「利用料」といいます。）を、当社が定める所定の方法により当社に支払うものとします。</li>

                <li>2. 掲載企業は、第14条各号に掲げる事由により本利用規約などに基づく契約が解除された場合には、期限の利益を喪失し、直ちに残債務の全額を当社に支払うものとします。</li>

                <li>3. 掲載企業は、利用料その他の債務の支払いを怠った場合、支払期日の翌日から支払いを完了する日まで年14.6％の割合による遅延損害金を当社に支払うものとします。</li>

                <li>4. 掲載企業は、解除または解約により本利用規約などに基づく契約の有効期間の満了前に本利用規約などに基づく契約が終了した場合であっても、当社に対し本利用規約などに基づく契約に基づく利用料全額の支払義務を負い、残りの契約期間分の利用料金を一括して支払うものとし、当社は受領した利用料の返金を行わないものとします。</li>
            </ul>
            <p className="terms-article-title">第13条（ご利用にあたっての禁止行為）</p>

            <p>本アカウントの登録ならびに本サービスの申込みおよび利用に際しては、以下に定める行為（それらを誘発する行為や準備行為も含みます。）を禁止します。</p>
            <p>(1){'\u3000'}本利用規約などに違反する行為</p>
            <p>(2){'\u3000'}法令または公序良俗に違反する行為</p>
            <p>(3){'\u3000'}法令・社会規範・公序良俗に反するもの、他人に不当な不快感を与えるもの、または他人の権利を侵害し、もしくは侵害するおそれのあるものを、投稿、掲載、開示、提供または送信（以下これら投稿、掲載、開示、提供または送信する行為を総称して「投稿など」といいます。）する行為</p>
            <p>(4){'\u3000'}事実と異なる不正確な情報を登録または掲載する行為</p>
            <p>(5){'\u3000'}当社の定めるガイドラインに反して情報を掲載する行為</p>
            <p>(6){'\u3000'}掲載企業に関する真実または正確でない情報を提供する行為その他当社、ユーザー、他の掲載企業または第三者に迷惑を及ぼす行為</p>
            <p>(7){'\u3000'}本サービスに係るユーザー向け企画の掲載を本サービス外で行う行為</p>
            <p>(8){'\u3000'}政治活動行為または宗教活動行為（ただし、当社が同意したものを除きます。）</p>
            <p>(9){'\u3000'}営利目的での本サービスの利用行為（ただし、当社が同意したものを除きます。）</p>
            <p>(10){'\u3000'}当社や他者になりすます行為</p>
            <p>(11){'\u3000'}スパム行為</p>
            <p>(12){'\u3000'}当社のサーバーまたはネットワークの機能を破壊、妨害する行為</p>
            <p>(13){'\u3000'}コンピュータウィルスなどの有害なコンピュータプログラムなどを送信または掲載する行為</p>
            <p>(14){'\u3000'}本サービス・当社の配信する広告、または本サービス上で提供されているサービス・広告を妨害する行為</p>
            <p>(15){'\u3000'}本サービスを複製、改変、逆アセンブル、逆コンパイルおよびリバースエンジニアリングなどする行為</p>
            <p>(16) 他の掲載企業またはユーザーの個人情報や履歴情報および特性情報（当社のプライバシーポリシーにて定義します。）などを他の掲載企業またはユーザーに無断で収集、蓄積、漏洩する行為</p>
            <p>(17) 本サービスまたは本サービスを通じて入手した情報を、提供の趣旨に背いた目的で利用する行為</p>
            <p>(18) 他の掲載企業またはユーザーの本アカウント情報を使用して本サービスを利用する行為</p>
            <p>(19) 手段の種類を問わず、他人から本アカウント情報を入手し、または他人に本アカウント情報を開示、提供する行為</p>
            <p>(20) 本サービスに関連して、反社会的勢力などに直接、間接に利益を提供する行為</p>
            <p>(21) 当社の信用を毀損する行為</p>
            <p>(22) その他、上記各号に準じて当社が不適切と判断する行為</p>

            <p className="terms-article-title">第14条（違反行為などへの対応）</p>

            <p>当社は、本サービスを適正に運営するため、以下の場合には、あらかじめ何らの通知をすることなく、掲載企業に対して、コンテンツその他の情報の全部もしくは一部の削除、本サービスの利用の一時停止もしくは制限、または掲載企業のアカウントの削除、登録取消しを含む本利用規約などに基づく契約の解除などの措置、あるいは、違反行為の中止・予防、送信または投稿した情報の自発的な削除・訂正を求める措置、違反事実を本サービス内外で開示する措置（違法行為の可能性がある場合における警察その他の公的機関への通報を含みます。）を講じることができるものとします。<br />
               また、掲載企業が複数の本アカウントを登録している場合には、それらすべての本アカウントに対して上記措置がとられる場合があります。<br />
               なお、当社は、本条に基づき当社が行った措置により掲載企業に生じた不利益や損害について、一切の責任を負わないものとします。<br /></p>

            <p>(1) 掲載企業が本利用規約などに定められている事項に違反した場合、またはそのおそれがあると当社が判断した場合</p>
            <p>(2) 当社にお支払いいただく代金について支払いの遅滞が生じた場合</p>
            <p>(3) 差押え、仮差押え、仮処分、租税滞納処分を受けた場合</p>
            <p>(4) 手形・小切手の不渡り処分を受け、またはその他支払い停止となった場合</p>
            <p>(5) 掲載企業が破産、民事再生もしくは会社更生の手続の申立てを受け、または掲載企業自らがそれらの申立てを行うなど、掲載企業の信用不安が発生したと当社が判断した場合</p>
            <p>(6) 営業を廃止したとき、または清算手続に入った場合</p>
            <p>(7) 本アカウント情報が反社会的勢力などによって登録もしくは使用された場合、またはそれらのおそれがあると当社が判断した場合</p>
            <p>(8) 掲載企業が1年間にわたって本アカウント情報または当社のサービスを使用していない場合</p>
            <p>(9) 当社から掲載企業に対する問合せその他の回答を求める連絡に対して1か月間応答がない場合</p>
            <p>(10) その他、当社と掲載企業との信頼関係が失われた場合など、当社と掲載企業との契約関係の維持が困難であると当社が判断した場合</p>

            <p className="terms-article-title">第15条（本サービスなどの再利用の禁止）</p>

            <p>掲載企業が、本サービスやそれらを構成するデータを、当該サービスの提供目的を超えて利用した場合、当社は、それらの行為を差し止める権利およびそれらの行為によって掲載企業が得た利益相当額を当社に対して支払うよう請求する権利を有します。</p>

            <p className="terms-article-title">第16条（当社に対する補償）</p>

            <p>掲載企業の行為が原因で生じたクレームなどに関する当社の対応に関連して、当社が費用を支出した場合または当社が第三者に対して賠償金などの支払いを行った場合、掲載企業は、当社が支出した費用や第三者に支払った賠償金など（当社がクレームなどへの対応のために負担した弁護士費用を含みます。）を負担するものとします。</p>

            <p className="terms-article-title">第17条（掲載企業のデータおよびコンテンツの取扱い）</p>
            <ul>
                <li>1.{'\u3000'}掲載企業が本サービスの利用にあたって本サービスに投稿などをしたコンテンツ（以下「投稿コンテンツ」といいます。）が著作物に該当する場合、その著作権は、掲載企業または投稿コンテンツの著作者に帰属し、当社が投稿コンテンツに関して著作権を取得することはありません。ただし、当社は、個人情報保護法その他の法令を遵守し掲載企業の個人情報に十分配慮した上で、本サービスの提供・維持・改善、本サービスの宣伝・プロモーション、またはメンテナンスその他の本サービスの円滑な運営のために、投稿コンテンツを複製、翻訳、翻案、上映、展示、頒布、譲渡、貸与、出版、自動公衆送信およびそのために必要な送信可能化を無償、無期限かつ地域非限定で行うことができるものとします。</li>

                <li>2.{'\u3000'}当社は、本利用規約などの順守状況などを確認する目的で、必要に応じて投稿コンテンツの内容を閲覧し、本利用規約などに照らして削除することができるものとします。</li>

                <li>3.{'\u3000'}掲載企業は、掲載企業による投稿コンテンツについては、ユーザー、他の掲載企業、第三者を含む閲覧者に一般公開されることが原則として前提となっていることをあらかじめ了承するものとします。</li>

                <li>4.{'\u3000'}掲載企業が、本サービスにおいて、複数のユーザーあるいは掲載企業の手によって引用、編集、記述、修正、削除など（以下「引用など」といいます。）がなされてひとつの情報が形成されていく機能を提供するサービスへ投稿などをされた場合には、当社は、掲載企業が投稿などをしたコンテンツをユーザーあるいは他の掲載企業が自由に引用などの利用を行うことを掲載企業が承認し、著作権、著作者人格権その他の権利を行使しないことを、掲載企業にお約束いただいたものとみなします。</li>

                <li>5.{'\u3000'}掲載企業は、当社および当社から権利を承継しまたは許諾された者に対し、著作者人格権を行使しないものとします。</li>

                <li>6.{'\u3000'}掲載企業は、自己の責任において投稿コンテンツのバックアップを行い、当社は、投稿コンテンツのバックアップを行う義務を負わないものとします。掲載企業が本サービスを利用して投稿または送信した投稿コンテンツが全部もしくは一部消滅し、または改ざんされた場合であっても、当社はそれを回復する責任を負いません。</li>

                <li>7.{'\u3000'}当社は、掲載企業の本アカウント削除後も、掲載企業が当社に提供した情報を任意で保有・利用・廃棄することができるものとします。</li>

                <li>8.{'\u3000'}当社は、本利用規約などに基づく契約の更新をしなかった、または、解約もしくは解除を行った掲載企業の登録情報・コンテンツについて、継続して保有する義務を負わないものとします。</li>
            </ul>
            <p className="terms-article-title">第18条（広告掲載）</p>

            <p>当社は、本サービス上に、当社または当社に掲載依頼をした第三者の広告を掲載することができるものとします。</p>

            <p className="terms-article-title">第19条（当社の免責事項）</p>
            <ul>
                <li>1.{'\u3000'}当社の債務不履行に基づく損害賠償責任は、当社の故意または重過失によらない場合には免責されるものとします。</li>

                <li>2.{'\u3000'}当社は、天災地変その他の不可抗力、掲載企業または第三者の責めに帰すべき事由により掲載企業に生じた損失（①ウイルスまたはハッキングによるサーバダウン、システム障害、データの流出、損壊および誤った情報の掲載、②掲載企業の操作ミスなどによるデータの流出、損壊、ならびに③当社のシステム環境の変化、当社のシステムの瑕疵を含みます。）につき、何らの責任も負わないものとします。</li>

                <li>3.{'\u3000'}当社は、本サービスの提供に関連して掲載企業間で生じたトラブル、ユーザー向け企画の実施に関して掲載企業とユーザーとの間に生じたトラブル、その他掲載企業間または掲載企業とユーザーの間に生じた一切のトラブル（インターネット上のトラブルおよび対面時のトラブルを含みますが、これらに限られません。）について、何らの責任も負わないものとします。</li>

                <li>4.{'\u3000'}当社は、①掲載企業が本サービスを利用したこと、または利用できなかったこと、②不正アクセスや不正な改変がなされたこと、③他の掲載企業による行為、④ユーザーによる行為、⑤第三者のなりすまし行為、⑥その他これらに準じて本サービスに関連する事項に起因しまたは関連して掲載企業に生じた一切の損害につき、損害賠償責任を負わないものとします。</li>
            </ul>
            <p className="terms-article-title">第20条（外部サービス利用上の注意）</p>

            <p>掲載企業が、本サービスの利用にあたり、Facebook、Twitter、LINEその他の外部サービスなどを利用する場合には、当該外部サービスについては、当該外部サービスを提供する企業または個人などが責任を負うものとし、当社は、当該外部サービスにつき、いかなる保証も行うものではありません。</p>

            <p className="terms-article-title">第21条（本利用規約などの変更について）</p>
            <ul>
                <li>1.{'\u3000'}当社は、当社が必要と判断した場合には、掲載企業に対する事前の通知なくして、本利用規約などの内容を変更することができるものとします。ただし、当該変更が掲載企業に大きな影響を与えると当社が合理的に判断する場合には、あらかじめ合理的な事前告知期間を設けるものとします。この場合において、掲載企業が本利用規約などの変更に同意しないときは、当社が別途定める場合を除いて、当該事前告知期間内に当社所定の方法により当社へ通知するものとします。</li>

                <li>2.{'\u3000'}変更後の本利用規約などは、当社が別途定める場合を除いて、本サービスの提供にあたり表示された時点から効力を生じるものとします。</li>

                <li>3.{'\u3000'}掲載企業が、本利用規約などの変更の効力が生じた後に本サービスを利用する場合には、変更後の本利用規約などのすべての記載事項に同意したものとみなされます。</li>
            </ul>
            <p className="terms-article-title">第22条（保守作業などによる一時的中断）</p>
            <ul>
                <li>1.{'\u3000'}当社は、次の各号いずれかの事由に該当する場合、掲載企業に事前に通知することなく、一時的に本サービスの提供を中断することがあります。<br /><br />
                    <ul>
                        <li>(1){'\u3000'}本サービスの仕様変更または本サービス提供のためのシステムまたは関連設備の保守または修繕を定期的または緊急に行うとき</li>
                        <li>(2){'\u3000'}当社が利用する通信回線、電力などの提供が中断されたとき</li>
                        <li>(3){'\u3000'}火災、停電などにより本サービスの提供ができなくなったとき</li>
                        <li>(4){'\u3000'}地震、台風、洪水、津波などの天災その他の非常事態が発生し、またそのおそれが生じたために、法令・指導により通信の制限などの要請、指示があった場合または当社が必要と判断したとき</li>
                        <li>(5){'\u3000'}法令の改正・成立などにより本サービスの運営が困難または不可能になった場合</li>
                        <li>(6){'\u3000'}技術的に不可能な事由により本サービスの提供ができなくなったとき</li>
                        <li>(7){'\u3000'}その他やむを得ない事由により本サービスの一時的な中断が必要と当社が判断したとき</li>
                    </ul>
                </li>

                <li>2.{'\u3000'}当社は、本サービスの提供の遅滞または一時的な中断が発生したとしても、これに起因して掲載企業または第三者が被った損害・不利益については、一切責任を負わないものとします。</li>
            </ul>
            <p className="terms-article-title">第23条（本サービスの中止）</p>

            <p>当社は、当社が定める相当程度の予告期間をもって掲載企業に本サービス上にて通知の上、本サービスの提供を中止することができます。</p>

            <p className="terms-article-title">第24条（契約期間、更新）</p>
            <ul>
                <li>1.{'\u3000'}本利用規約などに基づく契約の有効期間は、当社が定める所定の方法により、掲載企業がプランを選択し当社が承認することで決定される期間とします。</li>

                <li>2.{'\u3000'}掲載企業は、本利用規約などに基づく契約の更新を希望しない場合には、本利用規約などに基づく契約更新日までに、当社が定める所定の方法により、本利用規約などに基づく契約を更新しない旨当社に対して申告するものとします。掲載企業が当該申告を行わない場合には、掲載企業が本利用規約などに基づく契約の更新を希望したものとみなされ、従前と同様の内容で本利用規約などに基づく契約が更新され、本利用規約などに基づく契約は更新された期間有効に存続するものとします。</li>
            </ul>
            <p className="terms-article-title">第25条（契約期間途中の解約）</p>

            <p>掲載企業が、本利用規約などに基づく契約の期間中に当該契約の解約を希望する場合には、当社が定める所定の方法により当社に届け出るものとします。</p>

            <p className="terms-article-title">第26条（存続条項）</p>

            <p>本利用規約などに基づく契約終了後も、本利用規約第3条（従事者数の申告）第3項、第5条（掲載企業に関する情報の取扱い）、第6条（利用履歴など）第1項および第3項、第8条（本サービスの内容に関する変更）、第12条（利用料の支払い）第2項ないし第4項、第15条（本サービスなどの再利用の禁止）、第16条（当社に対する補償）、第17条（掲載企業のデータおよびコンテンツの取扱い）、第19条（当社の免責事項）、第30条（秘密保持）、第32条（準拠法、裁判管轄）は有効に存続するものとします。</p>

            <p className="terms-article-title">第27条（通知または連絡）</p>

            <p>掲載企業が当社への連絡を希望する場合には、当社が指定するメールアドレス(info@readytofashion.jp)宛てのメールにより行っていただくものとします。当社は、掲載企業からのお問い合わせに対する回答を原則としてメールのみで行います。なお、当社は掲載企業からのお問い合わせに対して回答する義務を負うものではありません。</p>

            <p className="terms-article-title">第28条（権利義務などの譲渡の禁止）</p>

            <p>掲載企業は、本利用規約などに基づくすべての契約について、その契約上の地位およびこれにより生じる権利義務の全部または一部を、当社の書面による事前の承諾なく、第三者に譲渡もしくは貸与し、または担保に供することはできません。</p>

            <p className="terms-article-title">第29条（事業譲渡などの場合）</p>

            <p>当社が、本サービスまたは本サービスに関する事業を、事業譲渡し、または合併もしくは会社分割などにより第三者に承継させた場合、当社は、当該事業の承継に伴い、本利用規約などに基づく契約上の地位、権利および義務ならびに掲載企業の登録情報その他の情報を、当該事業の譲受人に譲渡または承継させることができるものとします。掲載企業は、当該譲渡または承継についてあらかじめこれに同意したものとみなします。</p>

            <p className="terms-article-title">第30条（秘密保持）</p>

            <p>掲載企業は、本サービスに関連して知り得た機密情報および当社が掲載企業に対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の書面による事前の承諾がある場合を除き、秘密に取り扱うものとし、第三者に開示することはできないものとします。</p>

            <p className="terms-article-title">第31条（本利用規約などの適用制限）</p>

            <p>本利用規約などの規定が、掲載企業との本利用規約などに基づく契約に適用される関連法令に反するとされる場合、当該規定は、その限りにおいて、当該掲載企業との間で成立した本利用規約などに基づく契約には適用されないものとします。ただし、この場合であっても、本利用規約などの他の規定の効力には影響しないものとします。</p>

            <p className="terms-article-title">第32条（準拠法、裁判管轄）</p>

            <p>本利用規約などの成立、効力発生、解釈にあたっては、日本法を準拠法とします。また、本サービス（掲載内容や広告などを含みます。）に起因または関連して当社と掲載企業との間で生じた紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>

            <p>(附則)</p>

            <p>平成29年1月27日制定・適用<br />
                平成29年8月1日改訂・適用<br />
                平成31年1月15日改訂・適用</p>
        </div>
        </div>
        {/* end company-term */}
    </div>
  );
};
